import { VGroundRemote } from "../api/ground";
import { VApartmentGround, VHouseGround, VOfficeGround, VRetailBuildingGround, VRetailShopGround, VWarehouseGround } from "../common/ground";
import { getGarageRange } from "../garage";

export function mapVApartmentGroundRemoteToDomain(remote: VGroundRemote): VApartmentGround {
  return {
    indoorGarage: getGarageRange(remote.indoor_garage),
    indoorGarageComment: remote.indoor_garage_comment,
    outdoorGarage: getGarageRange(remote.outdoor_garage),
    outdoorGarageComment: remote.outdoor_garage_comment,
    externalAreas: remote.external_areas_name,
    externalAreasComment: remote.external_area_comment
  }
}

export function mapVHouseGroundRemoteToDomain(remote: VGroundRemote): VHouseGround {
  return {
    indoorGarage: getGarageRange(remote.indoor_garage),
    indoorGarageComment: remote.indoor_garage_comment,
    outdoorGarage: getGarageRange(remote.outdoor_garage),
    outdoorGarageComment: remote.outdoor_garage_comment,
    garden: remote.garden_name,
    gardentComment: remote.garden_comment
  }
}

export function mapVOfficeGroundRemoteToDomain(remote: VGroundRemote): VOfficeGround {
  return {
    indoorGarage: getGarageRange(remote.indoor_garage),
    indoorGarageComment: remote.indoor_garage_comment,
    outdoorGarage: getGarageRange(remote.outdoor_garage),
    outdoorGarageComment: remote.outdoor_garage_comment,
    externalAreas: remote.external_areas_name,
    externalAreasComment: remote.external_area_comment
  }
}

export function mapVRetailBuildingGroundRemoteToDomain(remote: VGroundRemote): VRetailBuildingGround {
  return {
    indoorGarage: getGarageRange(remote.indoor_garage),
    indoorGarageComment: remote.indoor_garage_comment,
    outdoorGarage: getGarageRange(remote.outdoor_garage),
    outdoorGarageComment: remote.outdoor_garage_comment,
    outdoorSpace: remote.outdoor_space_name,
    outdoorSpaceComment: remote.outdoor_space_comment
  }
}

export function mapVRetailShopGroundRemoteToDomain(remote: VGroundRemote): VRetailShopGround {
  return {
    indoorGarage: getGarageRange(remote.indoor_garage),
    indoorGarageComment: remote.indoor_garage_comment,
    outdoorGarage: getGarageRange(remote.outdoor_garage),
    outdoorGarageComment: remote.outdoor_garage_comment,
    externalAreas: remote.external_areas_name,
    externalAreasComment: remote.external_area_comment
  }
}

export function mapVWarehouseGroundRemoteToDomain(remote: VGroundRemote): VWarehouseGround {
  return {
    indoorGarage: getGarageRange(remote.indoor_garage),
    indoorGarageComment: remote.indoor_garage_comment,
    outdoorGarage: getGarageRange(remote.outdoor_garage),
    outdoorGarageComment: remote.outdoor_garage_comment,
    outdoorSpace: remote.outdoor_space_name,
    outdoorSpaceComment: remote.outdoor_space_comment
  }
}